import React, { Component } from 'react';

import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createNumberMask } from 'redux-form-input-masks';

import * as formatter from 'helpers/Formatter';
import { TextField, DatePicker } from 'redux-form-material-ui';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import ReassignAgent from './ReassignAgent';

import * as validator from 'helpers/Validator';

import { getProperties, getUnits, showUnits } from 'actions/landlordPropertiesActions';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import LeaseItems from 'components/shared/LeaseItems/LeaseItems';
import Header from 'components/shared/Header';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import YardiLeaseCharge from './YardiLeaseCharge';

let LeaseDetailsForm = class LeaseDetailsForm extends Component {
  isEditable = () => {
    return (
      this.props.leaseDetails.editable && featureEnabled('ui.rent_roll_page.edit_lease_detail')
    );
  };

  render() {
    const { leaseDetails } = this.props;
    let depositVerbiage = getTranslatedString('landlordPortal.leaseDetailsForm.rentalDeposit');
    if (leaseDetails.has_renewal) {
      depositVerbiage = getTranslatedString('landlordPortal.leaseDetailsForm.rentalDepositTopUp');
    }

    // One off of the default in Formatter.js to force values to be 0
    const currencyMask = createNumberMask({
      prefix: '$',
      decimalPlaces: 2,
      locale: 'en-US',
      allowEmpty: false,
    });

    return (
      <form autoComplete="off">
        <div className="row">
          <Header name={getTranslatedString('landlordPortal.leaseDetailsForm.leaseOverview')} />

          <div className="row" style={{ padding: '0 15px' }}>
            <div className="row">
              <div className="col-sm-6">
                <Field
                  name="lease_start_date"
                  component={DatePicker}
                  openToYearSelection
                  style={{ fontSize: '14px', width: '100%' }}
                  formatDate={formatter.reformatDate}
                  textFieldStyle={{ fontSize: '14px', width: '100%' }}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.leaseDetailsForm.startLeaseDate'
                  )}
                  validate={[validator.required]}
                  disabled={!this.isEditable()}
                />
              </div>
              <div className="col-sm-6">
                <Field
                  name="lease_end_date"
                  component={DatePicker}
                  openToYearSelection
                  style={{ fontSize: '14px', width: '100%' }}
                  formatDate={formatter.reformatDate}
                  textFieldStyle={{ fontSize: '14px', width: '100%' }}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.leaseDetailsForm.endLeaseDate'
                  )}
                  validate={[validator.required, validator.dateLeaseRange]}
                  disabled={!this.isEditable()}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <Field
                  name="early_move_in_date"
                  component={DatePicker}
                  openToYearSelection
                  style={{ fontSize: '14px', width: '100%' }}
                  formatDate={formatter.reformatDate}
                  textFieldStyle={{ fontSize: '14px', width: '100%' }}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.leaseDetailsForm.earlyMoveInDate'
                  )}
                  validate={[validator.required, validator.dateLeaseRange]}
                  disabled={!this.isEditable()}
                />
              </div>
            </div>
            <div className="row radiobutton-label" style={{ marginTop: '15px' }}>
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <h4 style={{ fontWeight: 'bold' }}>
                  <TenantResidentVerbiageHelper
                    translatedTenant={getTranslatedString(
                      'landlordPortal.leaseDetailsForm.tenantMonthToMonthLease'
                    )}
                    translatedResident={getTranslatedString(
                      'landlordPortal.leaseDetailsForm.residentMonthToMonthLease'
                    )}
                  />
                </h4>
              </div>
              <div style={{ textAlign: 'justify', padding: '0 15px' }}>
                <TenantResidentVerbiageHelper
                  translatedTenant={getTranslatedString(
                    'landlordPortal.leaseDetailsForm.tenantIfMonthToMonthLease'
                  )}
                  translatedResident={getTranslatedString(
                    'landlordPortal.leaseDetailsForm.residentIfMonthToMonthLease'
                  )}
                />
              </div>
              <div className="col-sm-12" style={{ textAlign: 'center', margin: '15px 0' }}>
                <BooleanRadioButtons
                  name="month_to_month"
                  style={{ width: '187px', margin: 'auto' }}
                  disabled={!this.isEditable()}
                />
              </div>
            </div>
          </div>
        </div>

        <Header name={getTranslatedString('landlordPortal.leaseDetailsForm.leasePricing')} />

        <div className="row" style={{ padding: '0 15px' }}>
          <div className="row" style={{ margin: '15px 0' }}>
            <p style={{ padding: '0 15px 15px', textAlign: 'justify' }}>
              <b style={{ fontFamily: 'Circular-Bold', color: '#ff3434' }}>
                {getTranslatedString('landlordPortal.leaseDetailsForm.warning')}
                &nbsp;
              </b>
              {getTranslatedString('landlordPortal.leaseDetailsForm.leasePricingWarning')}
            </p>

            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name="monthly_rent"
                type="text"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.leaseDetailsForm.monthlyRent'
                )}
                validate={[validator.required]}
                disabled={!this.isEditable()}
                style={{ marginTop: '-15px', fontSize: '14px', width: '100%' }}
                {...currencyMask}
              />
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name="deposit_amount"
                type="text"
                component={TextField}
                floatingLabelText={depositVerbiage}
                validate={[validator.required]}
                disabled={!this.isEditable()}
                style={{ marginTop: '-15px', fontSize: '14px', width: '100%' }}
                {...currencyMask}
              />
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name="key_deposit"
                type="text"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.leaseDetailsForm.keyDeposit'
                )}
                disabled={!this.isEditable()}
                style={{ marginTop: '-15px', fontSize: '14px', width: '100%' }}
                {...currencyMask}
              />
            </div>
          </div>
        </div>
        {this.renderLeaseItems()}
        <ReassignAgent
          isRenewing={this.props.leaseDetails.is_renewing}
          propertyID={this.props.leaseDetails.property_id}
          renewalID={this.props.leaseDetails.renewal_id}
        />
      </form>
    );
  }

  renderLeaseItems = () => {
    const yardiLeaseCharges = this.props.leaseDetails.yardi_lease_charges || [];
    if (this.props.leaseDetails.property.yardi_based) {
      return (
        <div className="row">
          <Header name={getTranslatedString('landlordPortal.leaseDetailsForm.leaseCharges')} />

          {yardiLeaseCharges.map(leaseCharge => <YardiLeaseCharge leaseCharge={leaseCharge} />)}
        </div>
      );
    } else {
      return (
        <div className="row">
          <Header name={getTranslatedString('landlordPortal.leaseDetailsForm.ancillaryItems')} />

          <div className="row" style={{ padding: '0 15px' }}>
            <LeaseItems formName={this.props.form} disabled={!this.isEditable()} />
          </div>
        </div>
      );
    }
  };
};

export default compose(
  connect(
    store => ({
      leaseDetails: store.leaseDetails.leaseDetails,
    }),
    {
      getUnits,
      getProperties,
      showUnits,
    }
  ),
  reduxForm({ enableReinitialize: true })
)(LeaseDetailsForm);
